import { Random } from '@framework/Random';
import { ServerValue } from '@framework/repository';
import { HashUtils } from '@framework/utils/HashUtils';
import type { ViewModelTagJSON, ServerValueTimestamp } from 'balus-common';

export class ViewModelTag {
  constructor(
    public readonly id: string,
    public readonly name: string,
    public readonly hashedName: string,
    public readonly createdAt: ServerValueTimestamp,
    public readonly updatedAt: ServerValueTimestamp
  ) {}

  dump(): ViewModelTagJSON {
    return {
      id: this.id,
      name: this.name,
      hashedName: this.hashedName,
      createdAt: this.createdAt,
      updatedAt: this.updatedAt,
    };
  }

  static load(dump: ViewModelTagJSON): ViewModelTag {
    return new this(dump.id, dump.name, dump.hashedName, dump.createdAt, dump.updatedAt);
  }

  static async buildNew(name: string) {
    return new this(
      Random.generateRandomID(),
      name,
      await HashUtils.hash(name),
      ServerValue.TIMESTAMP,
      ServerValue.TIMESTAMP
    );
  }

  static async fromOther(other: ViewModelTagJSON, name: string) {
    return new this(other.id, name, await HashUtils.hash(name), other.createdAt, ServerValue.TIMESTAMP);
  }
}
